export default "__VITE_ASSET__CtsVjrs4__"